module.exports = __webpack_public_path__ + "img/More Icon - white.02ab2bc4.svg";